import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/features/migrations/lexicalPluginToLexical/nodes/unknownConvertedNode/Component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/features/migrations/slateToLexical/nodes/unknownConvertedNode/Component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AnimatedFeatures/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProducts"] */ "/app/src/components/FeaturedProducts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomepageAdCarousel"] */ "/app/src/components/HomepageAdCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ShopByCategories/index.tsx");
